import { useEffect } from 'react';
import { URL_SECURITY_BASE } from '../config/config.json';

const RedirectComponent = () => {
  useEffect(() => {
    window.location.href = URL_SECURITY_BASE;
  }, []);

  return null;
};

export default RedirectComponent;